/** Account blob synced across devices for a signed-in user. */
export const ACCOUNT_DATA_VERSION = 1;

export type AccountRecordsBests = {
  normal?: number;
  wasd?: number;
  superdot?: number;
  progression?: number;
  roulette?: number;
  sandbox?: number;
  highway?: number;
  darkness?: number;
  mirror?: number;
  snake?: number;
  combo?: number;
  overload?: number;
  colorrush?: number;
  heat?: number;
  hunter?: number;
  pop?: number;
  counter?: number;
  aim?: number;
  hook?: number;
  tilt?: number;
  orbit?: number;
  delay?: number;
};

export type AccountSandboxPresetRow = {
  name: string;
  config: unknown;
  cloudPresetId?: string;
  lastSpeedrunMs?: number;
};

export type AccountDataPayloadV1 = {
  version: typeof ACCOUNT_DATA_VERSION;
  records?: {
    bests?: AccountRecordsBests;
    speedrunTimes?: Record<string, number>;
    sandboxSpeedrunLocal?: Record<string, number>;
  };
  stats?: {
    totalPlayTimeSec?: number;
    totalDeaths?: number;
  };
  settings?: Record<string, string>;
  settingsUpdatedAt?: string | null;
  achievements?: {
    toastKnownIds?: string[];
  };
  sandbox?: {
    localPresets?: AccountSandboxPresetRow[];
    saveIsPublic?: boolean;
  };
  dots?: {
    balance?: number;
    dailyStreak?: number;
    lastLoginDate?: string | null;
    ownedCosmeticIds?: string[];
    equippedCosmeticIds?: string[];
    /** @deprecated use equippedCosmeticIds */
    equippedCosmeticId?: string | null;
    /**
     * Per-channel Theme cosmetic equip (cosmetic ids).
     * Each of background/balls/buttons/text may point at a different Theme item.
     */
    equippedThemeChannels?: {
      background?: string | null;
      balls?: string | null;
      buttons?: string | null;
      text?: string | null;
    };
    /** Saved inventory outfits (equip order preserved). */
    outfits?: Array<{
      id: string;
      name: string;
      equippedCosmeticIds: string[];
      cursorColor?: string;
      trailColor?: string;
    }>;
  };
  playStreaks?: {
    home?: { streak?: number; lastPlayDate?: string | null };
    modes?: Record<string, { streak?: number; lastPlayDate?: string | null }>;
  };
  /** IANA time zone for play-streak calendar days (e.g. America/Los_Angeles). */
  playStreakTimezone?: string;
};

export function emptyAccountPayload(): AccountDataPayloadV1 {
  return { version: ACCOUNT_DATA_VERSION };
}

export function asPayloadV1(raw: unknown): AccountDataPayloadV1 {
  if (!raw || typeof raw !== "object") return emptyAccountPayload();
  const o = raw as Record<string, unknown>;
  if (o.version !== ACCOUNT_DATA_VERSION) return emptyAccountPayload();
  return o as AccountDataPayloadV1;
}
